import { useSelector } from 'react-redux';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';
import { paramsQuoteDetailSelector } from 'src/redux/selectors/paramsQuoteDetailSelector';

export const ROW_PRODUCT_CODE = 'YGTROW';

const useQuoteTemplate = () => {
    const { isEvent, isSafariTemplate, productQuote } =
        useSelector(quoteDetailSelector);
    const params = useSelector(paramsQuoteDetailSelector);

    const isSafari: boolean = !!(params?.isSafariTemplate ?? isSafariTemplate);
    // Rest of World (non-event) quotes can also switch to the Safari template
    const isRowQuote: boolean =
        !isEvent && productQuote?.code === ROW_PRODUCT_CODE;

    return {
        isSafari,
        isRowQuote,
        isRowTemplate: isSafari && isRowQuote,
        isSafariLayout: isSafari,
        canSwitchSafariTemplate: !!isEvent || isRowQuote,
    };
};

export default useQuoteTemplate;
